import React from 'react';
import { Redirect } from 'react-router-dom';
import { If, Else, Then } from 'react-if';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
const ProjectByConfirmationTokenPage = _ref => {
  let {
    fullConfirmationToken
  } = _ref;
  return /*#__PURE__*/React.createElement(If, {
    condition: !!(fullConfirmationToken && fullConfirmationToken.projectId)
  }, /*#__PURE__*/React.createElement(Then, null, () => /*#__PURE__*/React.createElement(Redirect, {
    to: `/projet/${fullConfirmationToken.projectId}`
  })), /*#__PURE__*/React.createElement(Else, null, () => null));
};
const mapStateToProps = _ref2 => {
  let {
    project
  } = _ref2;
  return {
    fullConfirmationToken: project.fullConfirmationToken
  };
};
ProjectByConfirmationTokenPage.propTypes = {
  fullConfirmationToken: PropTypes.shape({
    projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
  })
};
export default connect(mapStateToProps, null)(ProjectByConfirmationTokenPage);